import React, { useEffect, useState, memo, Fragment } from 'react';
import { getNoticePopupList } from '@api/api';
import { BOARD_NOTICE_POPUP_CODE } from '@common/utils/board';
import { BoardItem } from '@container/board/elements';
import SatModal from '@components/common/satUI/SatModal';
import SatSlider from '@components/common/satUI/SatSlider';

const HomeMainNoticePopup = memo(
  ({ isOpen, onClose, onStopDisplay, popupSaveKey }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [postInfos, setPostInfos] = useState([]);

    const handleStopDisplay = () => {
      onStopDisplay(popupSaveKey, true);
      onClose();
    };

    useEffect(() => {
      let isMounted = true;

      const initPosts = async () => {
        const response = await getNoticePopupList({});

        const isSuccess = $utils.checkApiSuccess(response);

        if (isSuccess) {
          const data = $utils.getApiData(response);
          if (isMounted) setPostInfos(data);
        }

        if (isMounted) setIsLoaded(true);
      };

      initPosts();

      return () => {
        isMounted = false;
      };
    }, []);

    useEffect(() => {
      if (isLoaded && postInfos.length <= 0) {
        console.log('### 공지사항 팝업: 게시글 없음 (팝업 자동 종료)');
        onClose();
      }
    }, [isLoaded, postInfos]);

    return (
      isLoaded && (
        <SatModal type="swiper" visible={isOpen}>
          <header className="modal-header">
            <h3 className="layer-tit2">공지사항</h3>
          </header>

          <button className="btn-layer-close modal-close" onClick={onClose}>
            창닫기
          </button>

          <div className="cont">
            <SatSlider
              isNavigation
              className="swiper-box"
              options={{
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
              }}
              pages={postInfos.map((postInfo, index) => (
                <Fragment key={index}>
                  <BoardItem
                    type="popup"
                    boardTitle="공지사항"
                    boardCode={BOARD_NOTICE_POPUP_CODE}
                    postInfo={postInfo}
                  />
                </Fragment>
              ))}
            />

            <div className="check-wrap chk-style" onClick={handleStopDisplay}>
              <input readOnly id="today" type="checkbox" />
              <label htmlFor="today">오늘 하루 다시 보지 않기</label>
            </div>
          </div>
        </SatModal>
      )
    );
  },
);

HomeMainNoticePopup.propTypes = {
  isOpen: $propTypes.bool,
  onClose: $propTypes.func.isRequired, // 팝업닫기 버튼 클릭 핸들러
  onStopDisplay: $propTypes.func,
  popupSaveKey: $propTypes.string,
};

HomeMainNoticePopup.defaultProps = {
  isOpen: false,
  popupSaveKey: 'hideEntitlePopup',
};

export default HomeMainNoticePopup;
